import { render, staticRenderFns } from "./IsHoover.vue?vue&type=template&id=c1fe5392&scoped=true"
import script from "./IsHoover.vue?vue&type=script&lang=js"
export * from "./IsHoover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fe5392",
  null
  
)

export default component.exports